/**
 * Shared TransitionProps for MUI Popovers with frosted glass (backdrop-filter).
 *
 * MUI's Grow transition animates opacity 0→1 on the Paper element,
 * which breaks backdrop-filter on descendants (CSS compositing spec).
 * This override makes opacity complete in the first 20% on enter and
 * delay until the last 20% on exit, keeping backdrop-filter working
 * for ~80% of the animation.
 *
 * See .claude/rules/popover-backdrop-filter.md for full context.
 */
export const frostedGlassTransitionProps = {
  timeout: 300,
  onEntering: (node: HTMLElement) => {
    node.style.transition =
      'opacity 60ms cubic-bezier(0.4, 0, 0.2, 1), transform 200ms cubic-bezier(0.4, 0, 0.2, 1)';
  },
  onExiting: (node: HTMLElement) => {
    node.style.transition =
      'opacity 60ms cubic-bezier(0.4, 0, 0.2, 1) 240ms, transform 200ms cubic-bezier(0.4, 0, 0.2, 1)';
  },
};
